import { z } from 'zod';

import { LOGIN_REDIRECT_QUERY_PARAM } from 'shared/services';

import { EMAIL_VERIFIED_QUERY_PARAM, loginRedirectSchema } from '../shared';

/** Zod schema for `/auth/login` URL search params. */
export const loginSearchSchema = z.object({
  /** Set when the user has just verified their address, to confirm it on the login page. */
  [EMAIL_VERIFIED_QUERY_PARAM]: z.boolean().optional().catch(undefined),
  [LOGIN_REDIRECT_QUERY_PARAM]: loginRedirectSchema
});

export type LoginSearch = z.infer<typeof loginSearchSchema>;
